module.exports = __webpack_public_path__ + "img/logo15.cc8904e4.png";